export default "__VITE_ASSET__BKdx$bAG__"